import { Box, Chip, Typography } from '@mui/material';
import { ASSUMED_ABOVE_RANGE_VALUE, CONCENTRATION_UNITS } from '../../constants/report';
import { useThemeContext } from '../../contexts/BaseThemeContextProvider';

type CompoundChartChipMeaningProps = {
  lowerReportableValue: number;
  higherReportableValue: number;
};

export const CompoundChartChipMeaning = ({
  lowerReportableValue,
  higherReportableValue,
}: CompoundChartChipMeaningProps) => {
  const { theme } = useThemeContext();
  const boxStyles = {
    display: 'flex',
    margin: '15px 0px',
    gap: 0.5,
  };
  const chipStyles = {
    fontSize: '10px',
    backgroundColor: theme.custom.report.details.compoundCardsList.compoundCardChipMeaning.chip.default.backgroundColor,
    height: '26px',
    padding: '2px 8px 2px 6px',
    color: theme.custom.report.details.compoundCardsList.compoundCardChipMeaning.chip.default.color,
    '& .MuiChip-label': {
      padding: '0',
    },
  };
  const typographyStyles = {
    fontSize: '10px',
    margin: '5px 9px 0 0',
  };

  return (
    <Box
      sx={{
        color: theme.custom.report.details.compoundCardsList.compoundCardChipMeaning.boxStyles.color,
        display: { xs: 'block', md: 'flex' },
      }}
    >
      <Box sx={boxStyles}>
        <Chip
          label={
            <div
              style={{
                textAlign: 'center',
              }}
            >
              Detected (low)
            </div>
          }
          sx={{
            ...chipStyles,
            color: theme.custom.report.details.compoundCardsList.compoundCardChipMeaning.chip.belowRange.color,
          }}
        />{' '}
        <Typography variant="body2" sx={typographyStyles}>
          Less than {lowerReportableValue} {CONCENTRATION_UNITS}
        </Typography>
      </Box>
      <Box sx={boxStyles}>
        <Chip
          label={
            <div
              style={{
                textAlign: 'center',
              }}
            >
              Detected
            </div>
          }
          sx={{
            ...chipStyles,
            backgroundColor:
              theme.custom.report.details.compoundCardsList.compoundCardChipMeaning.chip.detected.backgroundColor,
          }}
        />{' '}
        <Typography variant="body2" sx={typographyStyles}>
          From {lowerReportableValue} to {higherReportableValue} {CONCENTRATION_UNITS}
        </Typography>
      </Box>
      <Box sx={boxStyles}>
        <Chip
          label={
            <div
              style={{
                textAlign: 'center',
              }}
            >
              &gt; {ASSUMED_ABOVE_RANGE_VALUE} {CONCENTRATION_UNITS}
            </div>
          }
          sx={{
            ...chipStyles,
            backgroundColor:
              theme.custom.report.details.compoundCardsList.compoundCardChipMeaning.chip.aboveRange.backgroundColor,
          }}
        />{' '}
        <Typography variant="body2" sx={typographyStyles}>
          More than {ASSUMED_ABOVE_RANGE_VALUE} {CONCENTRATION_UNITS}
        </Typography>
      </Box>
    </Box>
  );
};
